"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _checkmark = _interopRequireDefault(require("../../assets/checkmark"));

var _errormark = _interopRequireDefault(require("../../assets/errormark"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidationIcons = function ValidationIcons(_ref) {
  var browser = _ref.browser,
      error = _ref.error,
      focus = _ref.focus,
      iconRight = _ref.iconRight,
      touched = _ref.touched;
  return error ? /*#__PURE__*/_react.default.createElement(StyledErrormark, {
    color: "#F74040",
    focus: focus,
    right: iconRight,
    browser: browser ? browser.name : null
  }) : touched ? /*#__PURE__*/_react.default.createElement(StyledCheckmark, {
    color: "#00CD39",
    focus: focus,
    right: iconRight,
    browser: browser ? browser.name : null
  }) : null;
};

var StyledCheckmark = (0, _styledComponents.default)(_checkmark.default).withConfig({
  displayName: "StyledCheckmark"
})(["position:absolute;right:", ";bottom:1.3rem;max-width:2rem;transition:0.2s;object-fit:contain;"], function (_ref2) {
  var focus = _ref2.focus,
      right = _ref2.right;
  return focus ? right : '1rem';
});
var StyledErrormark = (0, _styledComponents.default)(_errormark.default).withConfig({
  displayName: "StyledErrormark"
})(["position:absolute;right:", ";bottom:1.2rem;max-width:2rem;transition:0.2s;object-fit:contain;"], function (_ref3) {
  var focus = _ref3.focus,
      right = _ref3.right;
  return focus ? right : '1rem';
});
ValidationIcons.displayName = 'ValidationIcons';
ValidationIcons.defaultProps = {
  error: '',
  touched: false
};
ValidationIcons.propTypes = {
  browser: _propTypes.object,
  iconRight: _propTypes.string,
  focus: _propTypes.bool,

  /** string with errormessage */
  error: _propTypes.string,

  /** boolean to check if inputfield is touched */
  touched: _propTypes.bool
};
ValidationIcons.displayName = 'ValidationIcons';
var _default = ValidationIcons;
exports.default = _default;